import { render, staticRenderFns } from "./goldArea.vue?vue&type=template&id=7ec02afe&scoped=true&"
import script from "./goldArea.vue?vue&type=script&lang=js&"
export * from "./goldArea.vue?vue&type=script&lang=js&"
import style0 from "./goldArea.vue?vue&type=style&index=0&id=7ec02afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec02afe",
  null
  
)

export default component.exports